import { createContext, useContext } from 'react'
import { observable, action } from 'mobx'

class FormFeedbackStore {
    @observable isOpen: boolean = false
    @action setIsOpen = (isOpen: boolean) => (this.isOpen = isOpen)

    @observable stationDetail: StationType | null = null
    @action setStationDetail = (data: StationType) => {
        this.stationDetail = data
    }

    @observable alertSuccess: boolean = false
    @action setAlertSuccess = (flag: boolean) => this.alertSuccess = flag
}

const formFeedbackStoreContent = createContext(new FormFeedbackStore())
const useFormFeedbackStore = () => useContext(formFeedbackStoreContent)

export default useFormFeedbackStore